import slajd2_2 from '../../files/images/photosPage/slajd2_2.jpg'
import slajd2_3 from '../../files/images/photosPage/slajd2_3.jpg'
import slajd2_4 from '../../files/images/photosPage/slajd2_4.jpg'
import slajd2_6 from '../../files/images/photosPage/slajd2_6.jpg'
import slajd2_8 from '../../files/images/photosPage/slajd2_8.jpg'
import slajd2_9 from '../../files/images/photosPage/slajd2_9.jpg'
import slajd2_10 from '../../files/images/photosPage/slajd2_10.jpg'
import slajd2_11 from '../../files/images/photosPage/slajd2_11.jpg'
import slajd2_12 from '../../files/images/photosPage/slajd2_12.jpg'
import slajd2_13 from '../../files/images/photosPage/slajd2_13.jpg'

const imagesSlider2 = [
    { image: slajd2_2, title: 'Helikopter'},
    { image: slajd2_3, title: 'Kościół Przemienienia Pańskiego'},
    { image: slajd2_4, title: 'Znaki na ścianie'},
    { image: slajd2_6, title: 'Strumyk w lesie'},
    { image: slajd2_8, title: 'Plaża'},
    { image: slajd2_9, title: 'Alejka'},
    { image: slajd2_10, title: 'Kościół'},
    { image: slajd2_11, title: 'Ulica nocą'},
    { image: slajd2_12, title: 'Motyl na kwiatku'},
    { image: slajd2_13, title: 'Rzeczka w lesie'},
  ];
  
  export default imagesSlider2;